import { createEnum } from "@redotech/zod-util/zod-enum";
import { ReturnStatus } from "./return-status";

export const ReturnStatusZod = createEnum(ReturnStatus, {
  enumName: "ReturnStatus",
});
